<template>
	<div class="order-detail" v-show="loaded">
		<div class="space"></div>
		<div class="section-title">订单编号
			<span>{{ order.order_no }}</span>
			<img v-if="order.has_signed" class="pull-right" src="/static/img/zytg.png" style="width:32px" @click="toServiceQr"/>
		</div>
		<div class="info-card">
			<div class="subtitle-info">套餐信息</div>
			<ul class="info-cont">
				<li><span class="label">套餐名称</span><span>{{ order.product_pkg_title }}</span></li>
				<li><span class="label">套餐价格</span><span>{{ order.order_price }}元</span></li>
				<li v-if="order.dikou_amount > 0"><span class="label">抵扣金额</span><span>{{ order.dikou_amount }}元</span></li>
				<li><span class="label">应付金额</span><span>{{ order.pay_price }}元</span></li>
				<li v-if="!order.has_signed"><span class="label">服务时长</span><span>{{ order.service_period }}个月</span></li>
				<li v-if="order.has_signed"><span class="label">服务时间</span><span>{{ order.service_start_date }} 至 {{order.service_end_date}}</span></li>
			</ul>
			<div class="subtitle-info top-line top-solid-line">购买人信息</div>
			<ul class="info-cont" > 
				<li><span class="label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span><span>{{ order.customer_name }}</span></li>
				<li><span class="label">手机号码</span><span>{{ order.security_mobile || '无'}}</span></li>
				<li><span class="label">回执编号</span><span>{{ order.survey_code || '无'}}</span></li>
				<li><span class="label">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型</span><span>{{ customer.rank_title || '无'}}</span></li>
			</ul>
			<div class="subtitle-info top-line top-solid-line" v-if="payments.length > 0">付款信息</div>
			<order-pay-item v-for="(item, index) in payments" :key="item.payment_id" :payment="item" role="customer" :last="index == payments.length-1"></order-pay-item>
		</div>
	</div>
</template>

<script>
import OrderPayItem from '@/components/OrderPayItem'

export default {
	name: 'OrderFullDetail',
	data: () => ({
		'order': {},
		'customer': {},
		'payments': [],
		'loaded': false,
		'showShareMask': false
	}),
	computed: {
	},
	created () {
	},
	components: {
		OrderPayItem
	},
	mounted: function () {
		this.setPageTitle('订单详情')
		this.fetchDetail()
	},
	methods: {
		fetchDetail () {
			this.loading('正在读取订单信息...')
			this.getOrderFullDetail(this.$route.params.id, 'full', rs => {
				this.order = rs.data.order
				this.customer = rs.data.customer
				this.payments = rs.data.payments
				if (this.order.service_status === 1 && (!this.customer.wx_userid || this.customer.wx_userid === '')) {
					if (this.order.is_qy_service === 1) {
						this.toServiceQr()
					} else {
						this.toNoQyService()
					}
				}
				this.loaded = true
			})
		},
		toServiceQr () {
			this.$router.push('/orders/service/complete/' + this.order.order_no)
		},
		toNoQyService () {
			this.$router.push('/noservice/order/done')
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// OrderFullDetail.vue?5a42bed8